import { render } from "./OrderModificationOfferTable.vue?vue&type=template&id=570d8bc7"
import script from "./OrderModificationOfferTable.vue?vue&type=script&lang=js"
export * from "./OrderModificationOfferTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__